export const CONTRACT_TYPES = {
  ORDERS: "orders",
  PREMIER: "premier",
  LOYALTY: "loyalty",
};

export const TOGGLE_LOADING = "TOGGLE_LOADING";
export const SET_CONTRACT_TYPE = "SET_CONTRACT_TYPE";
export const SET_FIRST_NAME = "SET_FIRST_NAME";
export const SET_LAST_NAME = "SET_LAST_NAME";
export const SET_EMAIL_ADDRESS = "SET_EMAIL_ADDRESS";
export const SET_ORDER_NUMBER = "SET_ORDER_NUMBER";
export const SET_ORDER_DATE = "SET_ORDER_DATE";
export const SET_DELIVERED_ON = "SET_DELIVERED_ON";

export const initialState = {
  loading: true,
  withdrawalFormDetails: {},
};

export const toggleLoading = () => ({ type: TOGGLE_LOADING });

export const setContractType = (contractType) => ({
  type: SET_CONTRACT_TYPE,
  contractType,
});

export const setFirstName = (firstName) => ({
  type: SET_FIRST_NAME,
  firstName,
});

export const setLastName = (lastName) => ({
  type: SET_LAST_NAME,
  lastName,
});

export const setEmailAddress = (email) => ({
  type: SET_EMAIL_ADDRESS,
  email,
});

export const setOrderNumber = (orderNumber) => ({
  type: SET_ORDER_NUMBER,
  orderNumber,
});

export const setOrderDate = (orderDate) => ({
  type: SET_ORDER_DATE,
  orderDate,
});

export const setDeliveredOn = (deliveredOn) => ({
  type: SET_DELIVERED_ON,
  deliveredOn,
});

// eslint-disable-next-line complexity
export const withdrawalFormDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_LOADING:
      return { ...state, loading: !state.loading };
    case SET_CONTRACT_TYPE:
      return {
        ...state,
        withdrawalFormDetails: {
          ...state.withdrawalFormDetails,
          contractType: action.contractType,
        },
      };
    case SET_FIRST_NAME:
      return {
        ...state,
        withdrawalFormDetails: {
          ...state.withdrawalFormDetails,
          firstName: action.firstName,
        },
      };
    case SET_LAST_NAME:
      return {
        ...state,
        withdrawalFormDetails: {
          ...state.withdrawalFormDetails,
          lastName: action.lastName,
        },
      };
    case SET_EMAIL_ADDRESS:
      return {
        ...state,
        withdrawalFormDetails: {
          ...state.withdrawalFormDetails,
          email: action.email,
        },
      };
    case SET_ORDER_NUMBER:
      return {
        ...state,
        withdrawalFormDetails: {
          ...state.withdrawalFormDetails,
          orderNumber: action.orderNumber,
        },
      };
    case SET_ORDER_DATE:
      return {
        ...state,
        withdrawalFormDetails: {
          ...state.withdrawalFormDetails,
          orderDate: action.orderDate,
        },
      };
    case SET_DELIVERED_ON:
      return {
        ...state,
        withdrawalFormDetails: {
          ...state.withdrawalFormDetails,
          deliveredOn: action.deliveredOn,
        },
      };
    default:
      return state;
  }
};
